import ChipRow from "./chip-row";

// Slowed Pro's billing, from the PRO button: what was paid, as Stripe has
// it (pro/billing.js), in the `.mood` slide-up sheet like Studio and
// Advanced. `billing` is { status: "loading" | "ready" | "missing", view,
// billingUrl }. Stripe's receipt and billing portal open in a tab; the
// chips are links, and a host with its own way of opening pages takes
// over through onLinkClick.
export default function BillingSheet({
  open,
  billing,
  onLinkClick,
  onManageSubscriptionClick,
}) {
  const status = billing?.status || "loading";
  const view = status === "ready" ? billing.view : null;
  const subscription = view && !view.lifetime;

  let subtitle = "Getting your billing details…";
  if (view) subtitle = view.note;
  if (status === "missing") {
    subtitle =
      "Slowed Pro is on. For your receipt and invoices, Billing & Invoices emails you a link.";
  }

  // Billing & Invoices is Stripe's billing portal (Payhook's manage_plan,
  // lifetime buyers included) through onManageSubscriptionClick. Without
  // the purchase on record (a 0.9.x grant, Payhook not answering) it is
  // Payhook's billing page, which emails a link.
  const items = [
    ...(view?.receiptUrl
      ? [
          {
            key: "receipt",
            label: "View Receipt",
            title: "Stripe's receipt for this purchase",
            href: view.receiptUrl,
          },
        ]
      : []),
    ...(view && onManageSubscriptionClick
      ? [
          {
            key: "billing",
            label: "Billing & Invoices",
            title: subscription
              ? "Change or cancel your plan, and see your invoices, in Stripe"
              : "Your receipts, invoices and card, in Stripe",
            href: billing?.billingUrl || "#!",
            onClick: () => onManageSubscriptionClick(),
          },
        ]
      : status === "missing" && billing?.billingUrl
        ? [
            {
              key: "billing",
              label: "Billing & Invoices",
              title: "Stripe emails you a link to your receipts and invoices",
              href: billing.billingUrl,
            },
          ]
        : []),
  ];

  return (
    <div
      id="mood-sheet"
      className={`mood mood--billing${open ? " mood--open" : ""}`}
      aria-label="Slowed Pro"
      aria-hidden={!open}
      aria-busy={status === "loading" || undefined}
      {...(!open ? { inert: true } : {})}
    >
      <div className="mood__header">
        <div className="mood__title-row">
          <div className="content__title">Slowed Pro</div>
          {view && <span className="mood__badge">{view.kind}</span>}
        </div>
        <p className="mood__subtitle">{subtitle}</p>
      </div>

      {status === "loading" && (
        <div className="billing__rows billing__rows--loading" aria-hidden="true" />
      )}
      {view && view.rows.length > 0 && (
        <dl className="billing__rows">
          {view.rows.map(([label, value]) => (
            <div className="billing__row" key={label}>
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      )}

      {items.length > 0 && (
        <ChipRow>
          {items.map((item) => (
            <a
              key={item.key}
              className="mood__chip"
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              title={item.title}
              tabIndex={open ? 0 : -1}
              onClick={(event) => {
                const handler =
                  item.onClick || (onLinkClick && (() => onLinkClick(item.href)));
                if (!handler) return;
                event.preventDefault();
                handler();
              }}
            >
              <span className="mood__chip-name">{item.label}</span>
            </a>
          ))}
        </ChipRow>
      )}
    </div>
  );
}
